import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import ChatScreen from "./pages/ChatScreen";
import AuthCallback from "./pages/AuthCallback";
import MagazinePrint from "./pages/MagazinePrint";
import Privacy from "./pages/Privacy";
import Terms from "./pages/Terms";
import Settings from "./pages/Settings";
import Paywall from "./pages/Paywall";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import PurchaseRestore from "./pages/PurchaseRestore";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Disclaimer from "./pages/Disclaimer";
import Support from "./pages/Support";
import Dashboard from "./pages/Dashboard";
import SplashScreen from "./components/SplashScreen";
import { AuthProvider } from "./lib/auth";
import { I18nProvider } from "./lib/i18n";
import "./App.css";

function AppRouter() {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash && location.hash.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<ChatScreen />} />
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/settings" element={<Settings />} />
      <Route path="/paywall" element={<Paywall />} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/support/purchase-restore" element={<PurchaseRestore />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/disclaimer" element={<Disclaimer />} />
      <Route path="/support" element={<Support />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/print/:tripId" element={<MagazinePrint />} />
      <Route path="*" element={<ChatScreen />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <I18nProvider>
        <AuthProvider>
          <SplashScreen minMs={900}>
            <AppRouter />
          </SplashScreen>
          <Toaster position="top-center" richColors />
        </AuthProvider>
      </I18nProvider>
    </BrowserRouter>
  );
}
